var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warning",
    transform: "translate(-1813 -260)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21199",
    "data-name": "Group 21199"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_898",
    "data-name": "Ellipse 898",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(1813 260)",
    fill: "#ededf2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21142",
    "data-name": "Group 21142",
    transform: "translate(471 -18.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Warning-2",
    "data-name": "Warning",
    d: "M10.485,3.87a3,3,0,0,1,5.031,0l7.472,11.5A3,3,0,0,1,20.472,20H5.528a3,3,0,0,1-2.515-4.635Z",
    transform: "translate(1348 284.419)",
    fill: "#cf1313"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5889",
    "data-name": "Rectangle 5889",
    width: 2,
    height: 7,
    rx: 1,
    transform: "translate(1360 290.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5890",
    "data-name": "Rectangle 5890",
    width: 2,
    height: 3,
    rx: 1,
    transform: "translate(1360 298.419)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.6de1f6dde32e03df6d100fdcf51db3c8.svg";
export { ForwardRef as ReactComponent };